import {Component, HostBinding, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {DashboardUrlModel} from '../../api/dashboard-url-model';
import {ActivatedRoute} from '@angular/router';
import {FilterStorageService} from '../../services/filter-storage.service';
import {DashboardService} from '../../api/dashboard.service';
import * as $ from 'jquery';
import * as moment from 'moment';

declare let QuickSightEmbedding: any;

@Component({
  selector: 'app-dashboard-frameless',
  templateUrl: './dashboard-frameless.component.html',
  styleUrls: ['./dashboard-frameless.component.scss']
})
export class DashboardFramelessComponent implements OnInit, OnDestroy {
  private dashboardName: string;
  private dashboard: DashboardUrlModel;

  @HostBinding('class') class = 'w-100 h-100';
  private organizationId: string;
  private startDate: string;
  private endDate: string;

  constructor(private route: ActivatedRoute,
              private filtersStorage: FilterStorageService,
              private dashboardService: DashboardService) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.dashboardName = params.dashboardName;
      this.resetDashboard();
      const _ = this.renderDashboard();
    });

    this.route.queryParams.subscribe((params: {organizationId: string, startDate: string, endDate: string}) => {
      this.organizationId = params.organizationId;
      this.startDate = params.startDate;
      this.endDate = params.endDate;
      const _ = this.renderDashboard();
    });
  }

  ngOnDestroy() {
  }

  async renderDashboard() {
    if (this.organizationId == null) { return ; }
    if (this.dashboardName == null) { return ; }

    if (this.dashboard == null) {
      try {
        this.dashboard = await this.dashboardService.getUrl(this.dashboardName).toPromise();
      } catch (e) {
        alert('Try ro refresh the page: ' + e.error.message);
        console.error(e);
        return;
      }
    }

    const containerDiv = document.getElementById('widgetContainer');
    $('#widgetContainer').empty();

    console.log(this.organizationId, this.startDate, this.endDate, moment(this.startDate), moment(this.endDate));

    const options = {
      url: this.dashboard.url,
      container: containerDiv,
      parameters: {
        OrganizationID: this.organizationId,
        StartDate: moment(this.startDate),
        EndDate: moment(this.endDate)
      },
      height: 'AutoFit',
      loadingHeight: '100%',
      width: '100%',
      style: 'border: none;'

    };

    const dashboard = QuickSightEmbedding.embedDashboard(options);
    dashboard.on('error', this.dashboardOnError);
    dashboard.on('load', this.dashboardOnLoad());
    setTimeout(() => {
      $('iframe').prop('frameborder', 0);
    }, 0);
  }

  dashboardOnError(arg) {
    console.error(arg);
    this.dashboard = null;
    const _ = this.renderDashboard();
  }

  dashboardOnLoad() {
    // do nothing
  }

  private resetDashboard() {
    this.dashboard = null;
  }
}
